import feathersClient, { makeServicePlugin, BaseModel } from '@/plugins/feathers-client'

class MarianaClassSessionType extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'MarianaClassSessionType'
  // Define default properties here
  static instanceDefaults() {
    return {
    }
  }
}
const servicePath = 'mariana/class-session-type'
const servicePlugin = makeServicePlugin({
  Model: MarianaClassSessionType,
  service: feathersClient.service(servicePath),
  servicePath
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin